module.exports = __webpack_public_path__ + "img/cevi_in_kotniki.f1d0bd1e.svg";